var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container has-text-white" },
      [
        _c("H1", { staticClass: "pageTitle" }, [_vm._v("FORGOT PASSWORD")]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showEnterEmail,
                expression: "showEnterEmail"
              }
            ],
            staticClass: "limitWidth top40"
          },
          [
            _c("div", [
              _vm._v("Please enter the email address you use to log in:")
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "accSettingsForm top20",
                attrs: { name: "form1", "data-vv-scope": "form1" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.doForgot.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "field",
                    class: { formError: _vm.errors.first("form1.email") }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|email",
                          expression: "'required|email'"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form1.email,
                          expression: "form1.email"
                        }
                      ],
                      staticClass: "input is-warning",
                      attrs: { type: "text", name: "email" },
                      domProps: { value: _vm.form1.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form1, "email", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "help is-danger" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.errors.first("form1.email")) +
                          "\n                    "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button top10 is-warning",
                    attrs: { id: "submit1", type: "submit" }
                  },
                  [_vm._v("SUBMIT")]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.backendresend,
                expression: "backendresend"
              }
            ]
          },
          [
            _c("div", { staticClass: "bottom10 is-size-4 top20" }, [
              _vm._v(
                "Please check your email. We sent you a temporary password. After retrieving it, please log in."
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button top10 is-warning top10",
                on: { click: _vm.openLogin }
              },
              [_vm._v("LOGIN")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showEnterPass,
                expression: "showEnterPass"
              }
            ],
            staticClass: "limitWidth"
          },
          [
            _c("div", { staticClass: "bottom10 top20" }, [
              _vm._v("A verification code was sent to "),
              _c("span", { staticClass: "has-text-weight-bold" }, [
                _vm._v(_vm._s(_vm.form1.email))
              ]),
              _vm._v(
                ". Please enter it and provide the new password you would like to use."
              )
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                attrs: { name: "form2", "data-vv-scope": "form2" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.doCode.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "field has-text-white",
                    class: { formError: _vm.errors.first("form2.code") }
                  },
                  [
                    _vm._v("\n                    Code:\n                    "),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form2.code,
                          expression: "form2.code"
                        }
                      ],
                      staticClass: "input is-warning has-text-white",
                      attrs: { type: "text", name: "code" },
                      domProps: { value: _vm.form2.code },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form2, "code", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "help is-danger" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.errors.first("form2.code")) +
                          "\n                    "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "field has-text-white",
                    class: { formError: _vm.errors.first("form2.Pass") }
                  },
                  [
                    _vm._v(
                      "\n                    New Password:\n                    "
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required: true,
                            min: 8,
                            regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/
                          },
                          expression:
                            "{required: true, min:8, regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/}"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form2.pass,
                          expression: "form2.pass"
                        }
                      ],
                      staticClass: "input is-warning has-text-white",
                      attrs: {
                        type: "password",
                        name: "Pass",
                        "data-vv-as": "New Password"
                      },
                      domProps: { value: _vm.form2.pass },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form2, "pass", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "help is-danger" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.errors.first("form2.Pass")) +
                          "\n                    "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "field has-text-white",
                    class: { formError: _vm.errors.first("form2.pass2") }
                  },
                  [
                    _vm._v(
                      "\n                    Confirm Password:\n                    "
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: true, is: _vm.form2.pass },
                          expression: "{required:true, is: form2.pass}"
                        }
                      ],
                      staticClass: "input is-warning has-text-white",
                      attrs: {
                        type: "password",
                        name: "pass2",
                        "data-vv-as": "Confirm Password"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "help is-danger" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.errors.first("form2.pass2")) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "is-size-8 has-text-weight-light" },
                      [
                        _vm._v(
                          "(At least 8 characters long, at least one number, at least one lowercase letter, at least one uppercase letter and at least one special character)"
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button top10 is-warning",
                    attrs: { id: "submit2", type: "submit" }
                  },
                  [_vm._v("SUBMIT")]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _vm.showDone
          ? _c("div", { staticClass: "limitWidth" }, [
              _c("div", [_vm._v("Your password was successfullly changed!")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button top10 is-warning",
                  on: { click: _vm.openLogin }
                },
                [_vm._v("LOGIN")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showError
          ? _c("div", { staticClass: "limitWidth" }, [
              _c("div", [
                _vm._v(
                  "There was an error changing your password. Please try again."
                )
              ])
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d577572", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d577572","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Forgot.vue
// module id = null
// module chunks = 